import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import * as BsIcons from "react-icons/bs";
import { IoPersonCircle } from "react-icons/io5";
import logoIventas from "../../../assets/images/logos/logo_darkblue.svg";

import {
  LinksContainer,
  LinkContainer,
  LinkIcon,
  LinkName,
} from "./links.style";
import {
  NavContainer,
  BrandSection,
  LogoPill,
  HeaderActions,
  HeaderProfile,
} from "./Nav.style";
import links from "../../../const/links";
import CONSTANTS from "../../../const/constants";
import SidebarModalComponent from "../sidebarModal/SidebarModal.component";

// Compañía de mobieffects iventas - todos los usuarios tienen acceso
const MOBIEFFECTS_COMPANY_ID = "5ed824990274390007afcc70";

const Nav = () => {
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);

  const handleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <NavContainer>
      {/* Brand Section - Left */}
      <BrandSection>
        <LogoPill>
          <img src={logoIventas} alt="iVentas" />
        </LogoPill>
      </BrandSection>

      {/* Navigation - Center */}
      <LinksContainer aria-label="Navegación principal">
        {links
          .filter(
            link => !(user.data.rol.name === 'groupadmin' && link.name === 'Equipo')
          ).filter(
            link => !(user?.data?.company?.isBoardsActive !== true && link.name === 'Boards')
          ).filter(
            link => {
              // Filtro especial para Dashboard (AI Summaries)
              if (link.name === 'Inicio') {
                const companyId = user.data?.company?.id;
                const isAiSummariesEnabled = user.data?.company?.isAiSummariesEnabled;
                const roleName = user.data?.rol?.name;
                const isSuperadmin = roleName === CONSTANTS.SUPERADMIN;

                // Para mobieffects iventas: habilitado para todos los usuarios
                if (companyId === MOBIEFFECTS_COMPANY_ID) {
                  return true;
                }

                // Para otras compañías: solo si isAiSummariesEnabled es true Y es superadmin
                if (isAiSummariesEnabled && isSuperadmin) {
                  return true;
                }

                return false;
              }

              // Acceso abierto explícito (otros links legacy)
              if (link.openAccess) {
                return true;
              }

              return true;
            }
          ).map((link) => {
            if (!user?.data?.permissions) return null;

            const hasPermission =
              link.openAccess ||
              link?.permissions?.some(
                (linkPermission) => user.data.permissions[linkPermission]
              );
            if (!hasPermission) return null;

            const IconComponent = link.icon ? BsIcons[link.icon] : null;
            const isActive = link.routes.some(
              (route) =>
                location.pathname === route ||
                location.pathname.startsWith(`${route}/`)
            );

            return (
              <LinkContainer
                key={link.routes[0]}
                type="button"
                onClick={() => history.push(link.routes[0])}
                isActive={isActive}
              >
                {IconComponent && (
                  <LinkIcon isActive={isActive}>
                    <IconComponent />
                  </LinkIcon>
                )}
                <LinkName>
                  {link.name === 'Boards' ? 'Tableros' : link.name === 'Inicio' ? 'Dashboard' : link.name}
                </LinkName>
              </LinkContainer>
            );
          })}
      </LinksContainer>

      {/* Actions Section - Right */}
      <HeaderActions>
        <HeaderProfile title="Perfil" onClick={handleModal}>
          <IoPersonCircle />
        </HeaderProfile>
      </HeaderActions>

      <SidebarModalComponent show={showModal} />
    </NavContainer>
  );
};

export default Nav;
